import { useMutation } from "react-query";
import { updateOfficeStatusDetails } from "../../../../../actions/Utilities/OfficeStatusDetails";
import { toast } from "components/toastNotification";
import { IOfficeStatusDetails } from "../types";
import { useRecoilState, useSetRecoilState } from "recoil";
import { editStateOfficeStatusDetails, 
  officeStatusDetailsReFetching } from "../atoms/atoms";

const useEditOfficeStatusDetails = () => {
  const setActionEditState = useSetRecoilState(editStateOfficeStatusDetails);
  const [isReFetching, setIsReFetching] = useRecoilState(
    officeStatusDetailsReFetching
  );
  
  const { mutate } = useMutation(
    (NewData: IOfficeStatusDetails) => updateOfficeStatusDetails(NewData),
    {
      onSuccess: (res) => {
        if (typeof res == "object") {
          toast.fire(
            "Updating Office Status Detail failed", 
            `Error: ${res.Message}`, 
            "error"
          );
        }
        else {
          if (res === "Success") {
            toast.fire("Success", "Office Status Detail Updated Successfully", "success");
          } 
          else if (res === "Operation Failed!") {
              toast.fire("Updating Office Status Detail failed", `Server Error: ${res}`, "error");
          } 
          else if (res === "The data already exists!") {
              toast.fire("Updating Office Status Detail failed", `Duplication Error: ${res}`, "error");
          } 
          else if (res.includes("Notification insert Failed")) {
              toast.fire("Success", `Office Status Detail Updated Successfully, BUT ${res}`, "warning");
          } 
          else if (res.includes("Action object")) {
              toast.fire("Updating Office Status Detail failed", `Error: ${res}`, "error");
          } 
          else {
              toast.fire("Updating Office Status Detail failed", `${res.Message}`, "error");
          }
        }
        
        // Redirect to View
        setActionEditState(false);

        // ReFetch Data
        setIsReFetching(isReFetching ? false : true);
      },
      onError: (error: any) => {
        toast.fire("Update Office Status Detail failed", `Error: ${error}`, "error");
      },
    }
  );
  return mutate;
};

export default useEditOfficeStatusDetails;
